<template>
  <div class="selectIncompleteOrderReason">
    <v-select
      v-model="inputedValue"
      item-text="label"
      item-value="value"
      :items="items"
      dense
      outlined
      return-object
      class="original-selectbox"
      hide-details
      :placeholder="$t('common.input_unselected_2')"
      :height="height"
      :no-data-text="$t('common.common_not-storage-register')"
    >
    </v-select>
  </div>
</template>

<script>
import { storageUtil } from '@/util'
import orderReason from '@/config/order/orderReason'

export default {
  name: 'SelectIncompleteOrderReason',
  components: {
    //
  },
  props: {
    value: {
      type: Object,
      require: false,
      default: () => ({
        start: '',
        end: ''
      })
    },
    height: { default: '32px' },
    hasDefault: { default: true }
  },
  data: () => ({
    items: []
  }),
  async created() {
    // const itemsTmp = await storageUtil.getStorageIdNameList()
    const itemsTmp = {
      data: [
        {
          value: orderReason.ORDER_REASON_TYPE_ID.CONFIRM,
          label: orderReason.ORDER_REASON_TYPE_LABEL.CONFIRM
        },
        {
          value: orderReason.ORDER_REASON_TYPE_ID.DETAIL,
          label: orderReason.ORDER_REASON_TYPE_LABEL.DETAIL
        },
        {
          value: orderReason.ORDER_REASON_TYPE_ID.END,
          label: orderReason.ORDER_REASON_TYPE_LABEL.END
        },
        {
          value: orderReason.ORDER_REASON_TYPE_ID.ARRIVAL_DATE,
          label: orderReason.ORDER_REASON_TYPE_LABEL.ARRIVAL_DATE
        }
      ]
    }
    this.items = itemsTmp ? itemsTmp.data : []
    if (itemsTmp && itemsTmp.data && this.hasDefault) {
      this.inputedValue = itemsTmp.data[0]
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.selectIncompleteOrderReason {
  width: 100%;
}
</style>
